import $ from 'jquery'

$(document).ready(() => {
  // Ranking
  $(".rankings-page #load-more-button").on("click", function () {
    $(".rankings-page #load-more-button").hide();
    $(".rankings-page #load-more-listing").fadeIn();
  });  
})